import React, { useEffect, useState } from 'react';
import BarChart from '../../core/Components/Barchart';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { useTranslation } from '../../core';
import { DateRangePicker } from "../../core/Components/DateRange";
import { addDays } from 'date-fns';
import { useSelector } from 'react-redux';
import * as dashboardSelectors from '../selectors';
import { getReturnsData } from '../actions';
import _ from 'lodash';
import useAction from '../../core/services/UseAction';
import ChartContainer from '../../core/Components/ChartContainer';
import { withoutNullValue } from '../../core/services/chartDataFilter';


const ReturnsDataDashboard = () => {

  const { t } = useTranslation();

  const [selection, setSelection] = useState(
    {
      startDate: addDays(new Date(), -7),
      endDate: new Date(),
      key: 'selection',
    }
  )
  const [usersSelection, setUserSelection] = useState([]);


  const getData = useAction(() => getReturnsData(selection.startDate, selection.endDate), [selection]);
  const data = useSelector(dashboardSelectors.returnsData);
  const isLoadingReturnsData = useSelector(dashboardSelectors.isLoadingReturnsData);

  useEffect(() => {
    getData();
  }, [selection])

  const onDateRangeChange = (which) => {
    setSelection(which.selection)
  }

  const onUserSelection = (userName) => {
    if (_.find(usersSelection, elem => elem === userName)) {
      setUserSelection(_.filter(usersSelection, i => i !== userName))
    } else {
      setUserSelection([...usersSelection, userName])
    }
  }

  // const data = [
  //   {
  //     "userName": "User1",
  //     "itemsReturnedPerHour": 0,
  //     "itemsReturned": 3,
  //     "itemsSent": 5,
  //     "itemsSentPerHour": 1,
  //     "hours": 25,
  //   },
  //   {
  //     "userName": "User2",
  //     "itemsReturnedPerHour": 23,
  //     "itemsReturned": 8,
  //     "itemsSent": 4,
  //     "itemsSentPerHour": 4,
  //     "hours": 9
  //   },
  //   {
  //     "userName": "User3",
  //     "itemsReturnedPerHour": 5,
  //     "itemsReturned": 1,
  //     "itemsSent": 5,
  //     "itemsSentPerHour": 2,
  //     "hours": 20
  //   },
  //   {
  //     "userName": "User4",
  //     "itemsReturnedPerHour": 40,
  //     "itemsReturned": 6,
  //     "itemsSent": 10,
  //     "itemsSentPerHour": 4,
  //     "hours": 12
  //   },
  //   {
  //     "userName": "User5",
  //     "itemsReturnedPerHour": 5,
  //     "itemsReturned": 0,
  //     "itemsSent": 5,
  //     "itemsSentPerHour": 4,
  //     "hours": 36
  //   },
  //   {
  //     "userName": "User6",
  //     "itemsReturnedPerHour": 18,
  //     "itemsReturned": 2,
  //     "itemsSent": 6,
  //     "itemsSentPerHour": 4,
  //     "hours": 40
  //   }, {
  //     "userName": "User7",
  //     "itemsReturnedPerHour": 12,
  //     "itemsReturned": 2,
  //     "itemsSent": 3,
  //     "itemsSentPerHour": 1,
  //     "hours": 38
  //   },
  //   {
  //     "userName": "User8",
  //     "itemsReturnedPerHour": 18,
  //     "itemsReturned": 6,
  //     "itemsSent": 2,
  //     "itemsSentPerHour": 1,
  //     "hours": 80
  //   },
  //   {
  //     "userName": "User9",
  //     "itemsReturnedPerHour": 40,
  //     "itemsReturned": 10,
  //     "itemsSent": 18,
  //     "itemsSentPerHour": 5,
  //     "hours": 21
  //   },
  //   {
  //     "userName": "User10",
  //     "itemsReturnedPerHour": 35,
  //     "itemsReturned": 4,
  //     "itemsSent": 3,
  //     "itemsSentPerHour": 6,
  //     "hours": 8
  //   },
  //   {
  //     "userName": "User11",
  //     "itemsReturnedPerHour": 23,
  //     "itemsReturned": 6,
  //     "itemsSent": 12,
  //     "itemsSentPerHour": 4,
  //     "hours": 34
  //   },
  //   {
  //     "userName": "User12",
  //     "itemsReturnedPerHour": 37,
  //     "itemsReturned": 14,
  //     "itemsSent": 3,
  //     "itemsSentPerHour": 6,
  //     "hours": 36
  //   },
  //   {
  //     "userName": "User13",
  //     "itemsReturnedPerHour": 14,
  //     "itemsReturned": 3,
  //     "itemsSent": 8,
  //     "itemsSentPerHour": 3,
  //     "hours": 10
  //   },
  //   {
  //     "userName": "User14",
  //     "itemsReturnedPerHour": 12,
  //     "itemsReturned": 4,
  //     "itemsSent": 23,
  //     "itemsSentPerHour": 12,
  //     "hours": 18
  //   }, {
  //     "userName": "User15",
  //     "itemsReturnedPerHour": 50,
  //     "itemsReturned": 18,
  //     "itemsSent": 23,
  //     "itemsSentPerHour": 18,
  //     "hours": 23
  //   },
  //   {
  //     "userName": "User16",
  //     "itemsReturnedPerHour": 10,
  //     "itemsReturned": 15,
  //     "itemsSent": 2,
  //     "itemsSentPerHour": 7,
  //     "hours": 16
  //   }
  // ]

  return (
    <Grid fluid className="dashboardContainer">
      <Row className="dashboardHeader">
        <Col xs>
          <DateRangePicker
            onChange={onDateRangeChange}
            showSelectionPreview={true}
            moveRangeOnFirstSelection={false}
            className={'PreviewArea'}
            months={3}
            ranges={[selection]}
            direction="horizontal"
          />
        </Col>
      </Row>
      <ChartContainer>
        <BarChart
          indexBy={'userName'}
          data={withoutNullValue(data, 'itemsReturnedPerHour')}
          loading={isLoadingReturnsData}
          title={t("returnsData.fields.itemsReturnedPerHour")}
          keys={['itemsReturnedPerHour']}
          textDisplayKey="userName"
          onUserSelection={onUserSelection}
          usersSelection={usersSelection}
        />
      </ChartContainer>
      <ChartContainer>
        <BarChart
          indexBy={'userName'}
          data={withoutNullValue(data, 'itemsReturned')}
          loading={isLoadingReturnsData}
          title={t("returnsData.fields.itemsReturned")}
          keys={['itemsReturned']}
          textDisplayKey="userName"
          onUserSelection={onUserSelection}
          usersSelection={usersSelection}
        />
      </ChartContainer>
      <ChartContainer>
        <BarChart
          indexBy={'userName'}
          data={withoutNullValue(data, 'hours')}
          loading={isLoadingReturnsData}
          title={t("returnsData.fields.hours")}
          keys={['hours']}
          textDisplayKey="userName"
          onUserSelection={onUserSelection}
          usersSelection={usersSelection}
        />
      </ChartContainer>
    </Grid>
  );
};

export default ReturnsDataDashboard;